import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    LinearProgress
} from '@mui/material';

const LandingDeleteDialog = ({ open, status, onConfirm, onCancel, onClose }) => {
    const isLoading = status === 'loading';
    const isSuccess = status === 'success';

    const handleClose = () => {
        if (!isLoading) {
            onClose();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="xs"
            disableEscapeKeyDown={isLoading}
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    padding: '8px'
                }
            }}
        >
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
                    <Typography variant="h6" sx={{ color: '#111827', fontWeight: 700, textAlign: 'center' }}>
                        {isSuccess ? 'Landing Page Borrada' : 'Seguro que deseas borrar esta landing page'}
                    </Typography>

                    {isLoading && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            <Typography variant="body2" sx={{ color: '#4b5563', textAlign: 'center' }}>
                                Borrando
                            </Typography>
                            <LinearProgress
                                sx={{
                                    height: 6,
                                    borderRadius: 999,
                                    backgroundColor: '#e5e7eb',
                                    '& .MuiLinearProgress-bar': { backgroundColor: '#ef4444' }
                                }}
                            />
                        </Box>
                    )}
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'center' }}>
                {status === 'confirm' && (
                    <>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={onConfirm}
                            autoFocus
                            sx={{ textTransform: 'none', minWidth: 90 }}
                        >
                            Si
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={onCancel}
                            sx={{ textTransform: 'none', minWidth: 90 }}
                        >
                            No
                        </Button>
                    </>
                )}

                {isSuccess && (
                    <Button
                        variant="contained"
                        onClick={onClose}
                        autoFocus
                        sx={{ textTransform: 'none', minWidth: 90 }}
                    >
                        OK
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default LandingDeleteDialog;
